import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { get_bucket_list_by_mentor_data_action } from "../../../redux/_actions";

function useSharedBucketList(props) {
  const [loading, setLoading] = useState(false);
  const [allbucketList, setAllBucketList] = useState([]);
  const [utmToken, setUtmToken] = useState(null);
  const [utmId, setUtmId] = useState(null);
  const [userToken, setUserToken] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const { sharedBucketListData } = useSelector(
    (state) => state.get_bucket_list_by_mentor_data_reducer
  );

  useEffect(() => {
    getUserToken();
    let url = new URL(window.location.href);
    let utmId = url.searchParams.get("utmid");
    let utmToken = url.searchParams.get("utm_token");
    setUtmId(utmId);

    setUtmToken(utmToken);
  }, []);

  useEffect(() => {
    getAllBucketLists();
  }, []);

  useEffect(() => {
    if (sharedBucketListData?.data) {
      setAllBucketList(
        sharedBucketListData?.data && sharedBucketListData.data?.results
      );
    }
  }, [sharedBucketListData]);

  const getUserToken = async (id) => {
    const token = await localStorage.getItem("jigsawUser");
    setUserToken(JSON.parse(token));
  };

  const getAllBucketLists = async () => {
    setLoading(true);
    await dispatch(get_bucket_list_by_mentor_data_action());
    setLoading(false);
  };
  const onViewClick = (id) => {
    navigate(`/view-bucket-detail/${id}`);
  };

  return {
    loading,
    allbucketList,
    onViewClick,
  };
}
export default useSharedBucketList;
